import { useEffect, useMemo } from "react";
import {
  Cart,
  CartItem,
  PaymentMethod,
  Product,
  ShippingMethod,
} from "../graphql/generated/graphql";

import { getLocaleFromPath } from "./getLocaleFromPath";

declare global {
  interface Window {
    pintrk: any;
    dataLayer: any;
    gtag: any;
  }
}

export enum Events {
  add2Cart = "add2Cart",
  removeFromCart = "removeFromCart",
  viewProduct = "viewProduct",
  viewCategory = "viewCategory",
  viewCategoryProducts = "viewCategoryProducts",
  viewBasket = "viewBasket",
  checkout = "checkout",
  paymentMethodChanged = "paymentMethodChanged",
  shippingMethodChanged = "shippingMethodChanged",
  purchased = "purchased",
  visitedHomePage = "visitedHomePage",
  customerRegistered = "customerRegistered",
}

class _EventBus {
  bus: {};
  constructor() {
    this.bus = {};
  }

  remove(id) {
    delete this.bus[id];
  }

  on(id: Events, callback) {
    this.bus[id] = callback;
  }

  dispatch(id, ...params) {
    if (this.bus[id]) this.bus[id](...params);
  }
}
export const EventBus = new _EventBus();

export interface ICheckout {
  cart: Cart;
  checkoutStep?: number;
  shippingMethod?: ShippingMethod | null;
  paymentMethod?: PaymentMethod | null;
}

export interface IViewContactInformation {
  cart: Cart;
  checkoutStep: number;
}

export interface IViewCategoryProducts {
  products: Product[];
}

export interface IViewBasket {
  cart: Cart;
}

export function trackEvent<R>(event: Events, params: R) {
  if (typeof window === "undefined" || typeof window.gtag === "undefined") {
    return;
  }
  window.gtag("event", event, params);
}

export function useTracker<R>(
  event: Events,
  payload: R,
  options = { skip: false }
) {
  const { skip } = options;

  useEffect(() => {
    if (!skip) trackEvent(event, payload);
  }, [skip, payload]);
}
